import { Component, Input, OnInit } from '@angular/core';

enum btnType {
  Primary = 'Primary',
  Group = 'Group',
  Dark = 'Dark'
}

@Component({
  selector: 'alv-btn',
  templateUrl: './alv-btn.component.html',
  styleUrls: ['./alv-btn.component.scss']
})
export class AlvBtnComponent implements OnInit {

  /** Pass this in to show an image in the button. */
  @Input() public imageName: string;

  /** Pass this in to show a different image when this is button marked as 'selected', which would typically be in button groups. */
  @Input() public selectedImageName: string;

  /** This is for a11y (accessibility). */
  @Input() public altText: string;

  /** This controls the theme of the button (Primary, Dark, or Group). */
  @Input() public type: btnType;

  /** Set this to true to show the [selectedImageName] image instead. */
  @Input() public selected: boolean;

  /** Any optional additional css classes. */
  @Input() public cssClass: string;

  /** Set to true to disable the button from being clicked. */
  @Input() public disabled: boolean;

  public btnClass: string;

  constructor() { }

  ngOnInit() {
    this.btnClass = `alv-btn`;

    if (this.cssClass) {
      this.btnClass += ` ${this.cssClass}`;
    }

    if (this.imageName) {
      this.imageName = `assets/images/${this.imageName}`;
      if (this.selectedImageName) {
        this.selectedImageName = `assets/images/${this.selectedImageName}`;
      } else {
        this.selectedImageName = this.imageName;
      }
      this.btnClass += ' image-btn';
    } else {
      this.btnClass += ' text-btn';
    }

    switch (this.type) {
      case btnType.Primary:
        this.btnClass += ' primary-coloring';
        break;
      case btnType.Dark:
        this.btnClass += ' dark-coloring';
        break;
      case btnType.Group:
        this.btnClass += ` group-btn`;
        break;
      default:
        this.btnClass += ' default-btn';
        break;
    }
  }

  onClick(e: Event) {
    if (this.disabled) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

}
